import { Utils } from '@/libs/Utils'
import React from 'react'
import { Form } from 'react-bootstrap'

const Content: React.FC<{ locale: string }> = ({ locale }) => {
    const t = new Utils(locale).Translation
    return (
        <Form.Group className="mb-3 mt-3 col-md-12 col-12">
            <Form.Label>{t("form.contact.content")} <span className="text-danger">*</span></Form.Label>
            <Form.Control required type="text" as="textarea" name="content" />
            <Form.Control.Feedback type="invalid">[{t("form.contact.content")}] {t("required.message")}</Form.Control.Feedback>
        </Form.Group>
    )
}

export default Content